"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.transformOrderToAnonymizedOrderForDriver = void 0;
const class_transformer_1 = require("class-transformer");
const AnonymizedOrderForDriver_1 = require("../models/AnonymizedOrderForDriver");
function transformOrderToAnonymizedOrderForDriver(order) {
    const anonymizedOrder = {
        _id: order._id,
        departureAt: order.departureAt,
        originLocationId: order.originLocationId,
        destinationLocationId: order.destinationLocationId,
        pickupAddress: order.pickupAddress,
        dropoffAddress: order.dropoffAddress,
        passengers: [],
        vehicles: order.vehicles,
        tollPrice: order.tollPrice,
        tollFee: order.tollFee,
        additionalPrice: order.additionalPrice,
        additionalFee: order.additionalFee,
        vehicleTypesPricesFees: order.vehicleTypesPricesFees,
        contentLocations: order.contentLocations,
        customLocations: order.customLocations,
        acceptedAt: order.acceptedAt,
        declinedAt: order.declinedAt,
        cancelledAt: order.cancelledAt,
        confirmedAt: order.confirmedAt,
        driverNote: "",
        customerNote: order.customerNote,
        status: order.status,
        paymentMethod: order.paymentMethod,
        pricingCurrency: order.pricingCurrency,
        discountIds: order.discountIds,
        type: order.type,
    };
    order.passengers.map((passenger) => {
        const anonymizedPassenger = {
            type: passenger.type,
            luggage: passenger.luggage,
            isAdult: passenger.isAdult,
            isChild: passenger.isChild,
            isLead: passenger.isLead,
            assignationId: passenger.assignationId || undefined,
        };
        anonymizedOrder.passengers.push(anonymizedPassenger);
    });
    return (0, class_transformer_1.plainToClass)(AnonymizedOrderForDriver_1.AnonymizedOrderForDriver, anonymizedOrder);
}
exports.transformOrderToAnonymizedOrderForDriver = transformOrderToAnonymizedOrderForDriver;
//# sourceMappingURL=transformOrderToAnonymizedOrderForDriver.js.map